<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-md
    .grid.is-labs.is-widescreen-3.is-tablet-6
      .column.u-mb-sm(v-for="item in $t('items')")
        h4: AppLink(:to="item.url" :title="item.title") {{item.title}}
        p {{item.desc}}
        .u-mt-ts
          AppLink(:to="item.url" title="$t('explore')" class="button-link is-small") {{$t('explore')}}

  .u-divider.u-mt-md

  section.u-mt-md
    .grid.is-widescreen-8.is-desktop-10
      .column
        h4.u-mb-0 {{$t('sec2')}}

  .u-divider.u-mt-md
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('sec3')")
    .grid.is-tablet-6.is-labs.u-mt-sm
      .column.u-mb-col(v-for="item in $t('sec3Items')")
        AppCardBox
          AppLink(:to="item.url" :title="item.title"  class="cardBox-url")
          h4 {{item.title}}
          p {{item.desc}}
  section.u-mt-md
    .grid.is-labs.is-ultrawide-6.is-widescreen-7.is-desktop-9.is-center
      .column
        Homer
  .u-mb-md

</template>

<script>
import AsymetricGrid from '~/components/PsudoRandomGrid';
import Homer from '~/components/Homer';

export default {
  components: {
    AsymetricGrid,
    Homer
  },
  meta: {
    logoText: 'learn',
    theme: ' is-light'
  },
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat learning",
    "pageDesc":"Discover Baianat learning opportunities both on the ground and online represented in Academy, Internships and workshops.",
    "mantra":"Take a step towards |your passion.",
    "items":{
      "1":{
        "title":"Academy",
        "url":"/academy",
        "desc":"Access books, courses and lessons in the field you are most interested in and build up your experience.",
        "thumb":"{CDN_URL}/default.jpg"
      },
      "2":{
        "title":"Books",
        "url":"/books",
        "desc":"Get comprehensive about your learning resources with Baianat books in business design, development and technology.",
        "thumb":"{CDN_URL}/default.jpg"
      },
      "3":{
        "title":"Internships",
        "url":"/internships",
        "desc":"Get a long term intense learning experience inside Baianat and participate in real projects.",
        "thumb":"{CDN_URL}/default.jpg"
      },
      "4":{
        "title":"Workshops",
        "url":"/workshops",
        "desc":"Have a real onground experience in our workshops that introduce you to new techniques and how to implement it.",
        "thumb":"{CDN_URL}/default.jpg"
      }
    },
    "explore":"Explore",
    "sec2":"We believe that learning is a continuous act that should never stop and from which one’s mentality starts to blossom.",
    "sec3":"More learning| opportunities",
    "sec3Items":{
      "1":{
        "title":"Labs",
        "desc":"Step into Baianat kitchen. See projects in progress and participate in the decision making process.",
        "url":"/labs"
      },
      "2":{
        "title":"Events",
        "desc":"Meet the community on ground and get to know more about different fields, production approaches and methodologies.",
        "url":"/events"
      }
    }


  },
  "ar": {
    "pageTitle":"التعلم",
    "pageDesc":"اكتشف الفرص المتاحة التي توفرها بيانات للتعلم سواء أوفلاين أو أونلاين المتمثلة في الأكاديمة والتدريب الداخلي وورش العمل. ",
    "mantra":"تعلم شغفك| الحقيقي",
    "items":{
      "1":{
        "title":"الأكاديمية",
        "url":"/academy",
        "desc":"يمكنك الوصول إلى الكتب، والدورات التدريبية، والدروس في المجال الذي تهتم به؛ لتبدأ في بناء معرفتك.",
        "thumb":"{CDN_URL}/default.jpg"
      },
      "2":{
        "title":"الكتب",
        "url":"/books",
        "desc":"احصل على معلومات شاملة حول مصادر التعلم المختلفة من خلال كتب بيانات في التصميم والأعمال التجارية والبرمجة والتكنولوجيا. ",
        "thumb":"{CDN_URL}/default.jpg"
      },
      "3":{
        "title":"التدريب الداخلي",
        "url":"/internships",
        "desc":"احصل على تجربة تعليمية مكثفة على المدى الطويل داخل بيانات وشارك في مشاريع حقيقية للمزيد من الممارسة. ",
        "thumb":"{CDN_URL}/default.jpg"
      },
      "4":{
        "title":"ورش العمل",
        "url":"/workshops",
        "desc":"تمتع بتجربة عمل حقيقية على أرض الواقع من خلال ورش العمل التي توفر لك تقنيات جديدة وكيفية تنفيذها.",
        "thumb":"{CDN_URL}/default.jpg"
      }
    },
    "explore":"اكتشف",
    "sec2":"نؤمن بأن التعليم هو عملية مستمرة يجب ألا تتوقف أبدًا والتي تجعل عقل كل فرد منا يزدهر ويكون أكثر انفتاحًا. ",
    "sec3":"المزيد من فرص |التعلم المتاحة.",
    "sec3Items":{
      "1":{
        "title":"المختبرات",
        "desc":"الق نظرة على مطبخ بيانات. وشاهد المشاريع التي نقوم بها لحظة بلحظة والتقدم الذي نحققه على طول الطريق، وشارك في عملية صنع القرار.",
        "url":"/labs"
      },
      "2":{
        "title":"الفعاليات",
        "desc":"تقابل مع المجتمع على الأرض واحصل على المزيد من المعرفة في المجالات المختلفة ومنهجيات الإنتاج ونظرياته.",
        "url":"/events"
      }
    }
  }
}
</i18n>
